import { darkModeTextColor } from "constants/colors";
import {
  BREAKPOINT_DESKTOP_XL,
  CHART_MAX_WIDTH,
  Z_INDEX,
} from "constants/constants";
import styled, { css } from "styled-components/macro";

export const PnlBarStyles = styled.div<{
  $normalizedPctWidth: number | undefined;
  $color: string | undefined;
}>`
  flex-grow: ${props =>
    props.$normalizedPctWidth === Infinity
      ? 999 /* Infinity / divide-by-zero occurs when all bars are non-production time e.g. NPS, Uncollected -- this 999 ensures they're visible */
      : /* show negatives as positives (so they're visible) */
        Math.abs(props.$normalizedPctWidth ?? 0)};
  margin-right: 2px;
  height: 16px;
  background: ${props => props.$color};
  position: relative;
  .rectArrowRight {
    position: absolute;
    top: 2px;
    right: -6px;
    width: 12px;
    height: 12px;
    transform: rotate(45deg);
    background: ${props => props.$color};
  }
`;

export const PagesWrapperStyles = styled.div<{
  $isLoading: boolean;
  $pageWidth: number;
  $isAnimating: boolean;
  $doesOverflowHz: boolean;
}>`
  overflow: hidden;
  .scroll-container {
    width: 100%;
    position: relative;
    overflow-x: ${props =>
      /* hide overflow-x in case there happens to be a small redundant scrollbar */
      props.$isLoading || !props.$doesOverflowHz ? "hidden" : "auto"};
    display: flex;
    flex-direction: row;
    /* scroll-snap prevents smooth animation */
    ${props => (props.$isAnimating ? "" : "scroll-snap-type: x mandatory;")}
  }
  .page {
    scroll-snap-align: start;
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    width: ${props => props.$pageWidth}px;
    overflow: hidden;
  }
`;

export const PnlSummaryChartColumnsStyles = styled.div<{
  $isDarkMode: boolean;
  $doesOverflowHz: boolean;
  $isTakingSnapshot: boolean;
}>`
  ${({ $isDarkMode }) =>
    $isDarkMode
      ? css`
          color: ${darkModeTextColor};
        `
      : ""}
  ${({ $doesOverflowHz }) =>
    $doesOverflowHz
      ? css`
          padding-top: 12px;
        `
      : ""}
  @media (max-width: ${BREAKPOINT_DESKTOP_XL}px) {
    max-width: ${CHART_MAX_WIDTH}px;
  }
  ${({ $isTakingSnapshot }) =>
    $isTakingSnapshot
      ? css`
          width: ${CHART_MAX_WIDTH}px;
          [class*="DataRowCellStyles"] {
            max-height: 22px;
            line-height: 1em;
          }
          .pnlColumn-title {
            width: 200px !important;
          }
        `
      : ""}
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: row;
  .spinnerWrapper {
    pointer-events: none;
    position: absolute;
    z-index: ${Z_INDEX.L1};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
